import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import getNewsOnPageAPI from '../../api/get-news-on-page';
import { INewOnPageResponse } from '../../utils/types/admin-types';
import {
  rejectGetNews,
  requestGetNews,
  reсeiveGetNews,
} from '../actions/main-page';

interface IGetNews {
  type: string;
  payload: {
    division: string;
    mode: string;
  }
}

interface INewOnPagResponses {
  news: INewOnPageResponse;
}

const getNews = function* getNews(action: IGetNews) {
  try {
    const response: INewOnPagResponses = yield call(getNewsOnPageAPI, action.payload.division, action.payload.mode);
    yield put(reсeiveGetNews({ news: response }));
  } catch (error) {
    yield put(rejectGetNews({ error }));
  }
};

export default function* getNewsWatcher() {
  yield takeLatest(requestGetNews, getNews);
}
